/* cache-bust: 1771226872 */

/* ==========================================================
   WWD Collection Hub — SEO / GEO / FAQ Engine
   ========================================================== */
(function(){
"use strict";

function ready(fn){
  if(document.readyState!=="loading") fn();
  else document.addEventListener("DOMContentLoaded",fn);
}

/* ---------- Utility ---------- */
var SVG_CHEVRON='<svg class="wwd-faq-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>';

function getPageType(){
  var body=document.body.className||"";
  if(body.indexOf("manufacturer-hub")>-1) return "manufacturer";
  if(body.indexOf("series-hub")>-1) return "series";
  if(body.indexOf("category-hub")>-1) return "category";
  /* Fallback: check from Shopify metafield */
  var pt=window.__wwd_page_type;
  if(pt){
    if(pt.indexOf("manufacturer")>-1) return "manufacturer";
    if(pt.indexOf("series")>-1) return "series";
    if(pt.indexOf("category")>-1) return "category";
  }
  return null;
}

function getCollectionTitle(){
  var h1=document.querySelector(".page-header");
  return h1?h1.textContent.trim():"";
}

function getCollectionHandle(){
  var path=window.location.pathname;
  return path.replace("/collections/","").replace(/\/$/,"");
}

/* ======================================================
   1. SEO: noindex filtered pages + canonical
   ====================================================== */
function injectSEO(){
  var params=window.location.search;
  var path=window.location.pathname;

  /* noindex for filtered pages */
  if(params && (params.indexOf("filter.")>-1 || params.indexOf("sort_by=")>-1)){
    var meta=document.createElement("meta");
    meta.name="robots";
    meta.content="noindex,follow";
    document.head.appendChild(meta);
  }

  /* Canonical always points to clean collection URL */
  var existing=document.querySelector('link[rel="canonical"]');
  var clean=window.location.origin+path;
  if(existing){
    existing.href=clean;
  } else {
    var link=document.createElement("link");
    link.rel="canonical";
    link.href=clean;
    document.head.appendChild(link);
  }
}

/* ======================================================
   2. JSON-LD Structured Data
   ====================================================== */
function injectStructuredData(pageType,title,faqs){
  var scripts=[];

  /* BreadcrumbList */
  var crumbs=[{"@type":"ListItem","position":1,"name":"Home","item":window.location.origin+"/"}];
  var pos=2;
  if(pageType==="manufacturer"){
    crumbs.push({"@type":"ListItem","position":pos++,"name":"Manufacturers","item":window.location.origin+"/collections"});
  } else if(pageType==="series"){
    crumbs.push({"@type":"ListItem","position":pos++,"name":"Products","item":window.location.origin+"/collections"});
    crumbs.push({"@type":"ListItem","position":pos++,"name":"FPGA Families","item":window.location.origin+"/collections/embedded-processors-fpgas"});
  } else {
    crumbs.push({"@type":"ListItem","position":pos++,"name":"Products","item":window.location.origin+"/collections"});
  }
  crumbs.push({"@type":"ListItem","position":pos,"name":title,"item":window.location.href.split("?")[0]});

  scripts.push({
    "@context":"https://schema.org",
    "@type":"BreadcrumbList",
    "itemListElement":crumbs
  });

  /* FAQPage */
  if(faqs && faqs.length>0){
    scripts.push({
      "@context":"https://schema.org",
      "@type":"FAQPage",
      "mainEntity":faqs.map(function(f){
        return {
          "@type":"Question",
          "name":f.q,
          "acceptedAnswer":{"@type":"Answer","text":f.a}
        };
      })
    });
  }

  /* ItemList (collection as item list) */
  scripts.push({
    "@context":"https://schema.org",
    "@type":"ItemList",
    "name":title,
    "url":window.location.href.split("?")[0],
    "numberOfItems":document.querySelectorAll(".product-item").length
  });

  scripts.forEach(function(schema){
    var el=document.createElement("script");
    el.type="application/ld+json";
    el.textContent=JSON.stringify(schema);
    document.head.appendChild(el);
  });
}

/* ======================================================
   3. FAQ Content Libraries
   ====================================================== */
var FAQ_MANUFACTURER=[
  {q:"How does WWD Parts verify the authenticity of {name} components?",a:"Every {name} component undergoes rigorous inspection following AS6081 and IDEA-STD-1010 standards. We provide full traceability documentation including certificates of conformance, date codes, and lot tracking for each shipment."},
  {q:"Does WWD Parts offer bulk or project-based pricing for {name} parts?",a:"Yes. Submit your BOM or contact our sales team for volume pricing on {name} components. We offer competitive project quotes with flexible MOQ options."},
  {q:"What is the typical lead time for {name} components?",a:"Lead times vary by part number and availability. In-stock items ship same day. For allocated or long-lead items, we leverage our global sourcing network to find the fastest available supply."},
  {q:"Can I get RoHS and REACH compliance documentation for {name} parts?",a:"Yes. We provide RoHS certificates, REACH declarations, and other environmental compliance documentation upon request for all {name} components."},
  {q:"How do I submit a BOM for {name} components?",a:"Upload your BOM on our Request Quote page or email it directly to sale@wwdparts.com. You will receive a detailed quote with pricing, availability, and lead times within 24 hours."},
  {q:"Does WWD Parts support sample orders for {name} products?",a:"Yes. We support sample and small-quantity orders for design validation and prototyping. Contact us for sample availability and pricing."},
  {q:"What packaging options are available for {name} components?",a:"We offer original factory packaging (tape & reel, tray, tube) as well as custom packaging to meet your production requirements. Anti-static and moisture-sensitive handling included."},
  {q:"What is the return and warranty policy for {name} parts?",a:"All components come with a quality guarantee. If any part fails inspection or does not meet specifications, we offer full replacement or refund within our warranty period."}
];

var FAQ_SERIES=[
  {q:"What applications is the {name} series best suited for?",a:"The {name} series is designed for a wide range of applications including industrial automation, telecommunications, aerospace & defense, automotive ADAS, and high-performance computing. Check the datasheet for specific application recommendations."},
  {q:"How does {name} compare to previous-generation or competing series?",a:"The {name} series typically offers improvements in performance, power efficiency, or integration compared to its predecessors. Key differentiators include enhanced logic density, faster transceivers, or lower power modes. Contact us for a detailed comparison guide."},
  {q:"How do I decode the {name} part number suffixes?",a:"Part number suffixes typically indicate speed grade, temperature range, package type, and environmental compliance. For example, -1 through -3 indicate speed grades, I/C/A indicate Industrial/Commercial/Automotive temperature ranges. Refer to the ordering guide in the datasheet."},
  {q:"How do I select the right temperature and reliability grade?",a:"Commercial grade (0°C to +85°C) suits most consumer and enterprise applications. Industrial grade (-40°C to +100°C) is recommended for harsh environments. Automotive grade meets AEC-Q100 requirements."},
  {q:"What are viable alternatives if {name} parts are unavailable?",a:"Alternative series depend on your specific requirements. Our engineering team can recommend pin-compatible or functionally equivalent replacements. Submit an inquiry and we will provide cross-reference options."},
  {q:"How do I determine pin and functional compatibility between variants?",a:"Check the migration guide in the manufacturer's documentation. Pin-compatible variants within the same family often share the same footprint. Our team can verify compatibility for your specific design."},
  {q:"Are datasheets and selection guides available for the {name} series?",a:"Yes. We provide links to official datasheets, selection guides, and application notes. Contact us if you need a specific document that is not listed on the product page."},
  {q:"How can I request a bulk quote for {name} components?",a:"Submit your requirements through our RFQ form or email your BOM to sale@wwdparts.com. We offer competitive volume pricing with flexible delivery options."}
];

var FAQ_CATEGORY=[
  {q:"What types of {name} are available at WWD Parts?",a:"We carry a comprehensive range of {name} from leading manufacturers including AMD/Xilinx, Intel/Altera, Lattice, Microchip, TI, Analog Devices, and more. Browse by subcategory or manufacturer to find your specific part."},
  {q:"How do I choose the right {name} for my application?",a:"Start by defining your key requirements: performance specs, package type, temperature range, and interface needs. Use our category filters to narrow down options, or contact our engineering team for selection guidance."},
  {q:"Can I get cross-references for {name} from different manufacturers?",a:"Yes. Our team can provide cross-reference recommendations for equivalent parts from different manufacturers. Submit your current part number and we will suggest alternatives."},
  {q:"What is the minimum order quantity for {name}?",a:"MOQ varies by part number and manufacturer. Many items are available in single quantities for prototyping. Contact us for volume pricing on production quantities."},
  {q:"Does WWD Parts offer technical support for {name} selection?",a:"Yes. Our engineering team provides free technical consultation to help you select the right components for your design. Email us your requirements or schedule a call."},
  {q:"How quickly can {name} be shipped?",a:"In-stock items ship same day before the cutoff time. For non-stock items, we source from our global network and provide estimated lead times within 24 hours of inquiry."}
];

function buildFaqs(template,name){
  return template.map(function(f){
    return {
      q: f.q.replace(/{name}/g,name),
      a: f.a.replace(/{name}/g,name)
    };
  });
}

/* ======================================================
   4. FAQ Accordion Renderer
   ====================================================== */
function renderFAQ(faqs,title){
  var section=document.createElement("div");
  section.className="wwd-faq-section";
  section.innerHTML='<h2>Frequently Asked Questions: '+title+'</h2>';

  faqs.forEach(function(f,i){
    var item=document.createElement("div");
    item.className="wwd-faq-item";
    item.setAttribute("itemscope","");
    item.setAttribute("itemprop","mainEntity");
    item.setAttribute("itemtype","https://schema.org/Question");
    item.innerHTML=
      '<div class="wwd-faq-q" role="button" aria-expanded="false">'+
        '<span itemprop="name">'+f.q+'</span>'+SVG_CHEVRON+
      '</div>'+
      '<div class="wwd-faq-a" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">'+
        '<div itemprop="text">'+f.a+'</div>'+
      '</div>';

    item.querySelector(".wwd-faq-q").addEventListener("click",function(){
      var open=item.classList.contains("is-open");
      /* Close all others */
      section.querySelectorAll(".wwd-faq-item.is-open").forEach(function(el){
        el.classList.remove("is-open");
        el.querySelector(".wwd-faq-q").setAttribute("aria-expanded","false");
      });
      if(!open){
        item.classList.add("is-open");
        this.setAttribute("aria-expanded","true");
      }
    });

    section.appendChild(item);
  });

  return section;
}

/* ======================================================
   5. Answer Card Renderer
   ====================================================== */
function renderAnswerCard(pageType,title,handle){
  var card=document.createElement("div");
  card.className="wwd-answer-card";

  var defn="", takeaways=[], links=[];

  if(pageType==="manufacturer"){
    defn=title+" is a leading semiconductor manufacturer whose components are widely used in industrial, automotive, telecommunications, and consumer electronics applications. WWD Parts provides verified "+title+" components with full traceability and competitive pricing.";
    takeaways=[
      "All "+title+" components verified to AS6081 and IDEA-STD-1010 standards",
      "Same-day shipping available for in-stock parts",
      "Volume pricing and BOM support for production quantities",
      "Full compliance documentation (RoHS, REACH, CoC) on request",
      "Global sourcing network for hard-to-find and allocated parts"
    ];
    links=[
      {text:"Browse "+title+" Categories",href:"/collections/"+handle},
      {text:"Request Quote",href:"/pages/rfq"},
      {text:"Upload BOM",href:"/pages/rfq"}
    ];
  } else if(pageType==="series"){
    defn="The "+title+" series is a family of high-performance semiconductor devices designed for demanding applications. Browse specifications, compare variants, and request quotes for "+title+" components at WWD Parts.";
    takeaways=[
      "Complete "+title+" variant catalog with key specifications",
      "Part number decoder for speed grade, temperature, and package",
      "Cross-reference guidance for migration and alternatives",
      "In-stock availability with same-day shipping options",
      "Technical support for design-in and selection"
    ];
    links=[
      {text:"View All "+title+" Parts",href:"/collections/"+handle},
      {text:"Request Datasheet",href:"/pages/rfq"},
      {text:"Get Quote",href:"/pages/rfq"}
    ];
  } else {
    defn=title+" components are essential building blocks for modern electronic systems. WWD Parts offers a comprehensive catalog of "+title+" from world-leading manufacturers, with verified quality and fast delivery.";
    takeaways=[
      "Wide selection from top manufacturers (AMD, Intel, TI, Analog Devices, etc.)",
      "Browse by subcategory, manufacturer, or series",
      "Competitive pricing with volume discounts",
      "Same-day shipping for in-stock components"
    ];
    links=[
      {text:"Browse Subcategories",href:"/collections/"+handle},
      {text:"Request Quote",href:"/pages/rfq"}
    ];
  }

  var html='<h2>About '+title+'</h2>';
  html+='<p class="wwd-answer-defn">'+defn+'</p>';
  html+='<ul class="wwd-answer-takeaways">';
  takeaways.forEach(function(t){ html+='<li>'+t+'</li>'; });
  html+='</ul>';
  html+='<div class="wwd-answer-links">';
  links.forEach(function(l){ html+='<a href="'+l.href+'">'+l.text+'</a>'; });
  html+='</div>';

  card.innerHTML=html;
  return card;
}

/* ======================================================
   MAIN
   ====================================================== */
ready(function(){
  var pageType=getPageType();
  if(!pageType) return;

  var title=getCollectionTitle();
  var handle=getCollectionHandle();
  if(!title) return;

  /* 1. SEO */
  injectSEO();

  /* 2. FAQ */
  var faqTemplate;
  if(pageType==="manufacturer") faqTemplate=FAQ_MANUFACTURER;
  else if(pageType==="series") faqTemplate=FAQ_SERIES;
  else faqTemplate=FAQ_CATEGORY;

  var faqs=buildFaqs(faqTemplate,title);

  /* 3. JSON-LD */
  injectStructuredData(pageType,title,faqs);

  /* 4. Render Answer Card (after H1 / collection description) */
  var descArea=document.querySelector(".collection-content")||document.querySelector(".page-header");
  if(descArea){
    var card=renderAnswerCard(pageType,title,handle);
    if(descArea.classList.contains("page-header")){
      descArea.parentNode.insertBefore(card,descArea.nextSibling);
    } else {
      descArea.parentNode.insertBefore(card,descArea.nextSibling);
    }
  }

  /* 5. Render FAQ (at bottom of main content, before recently viewed) */
  var mainContent=document.querySelector(".halo-collection-content .halo-page-content")||document.querySelector(".halo-collection-content");
  if(mainContent){
    var faqSection=renderFAQ(faqs,title);
    mainContent.appendChild(faqSection);
  }
});

})()

/* ═══ WWD Semiconductor Pro Toolbar v2 — URL-based filtering ═══ */
;(function(){
  "use strict";
  if(!document.body.classList.contains("wwd-hub-page")) return;

  /* Hide Ella native toolbar */
  var ellaToolbar = document.querySelector("toolbar-item.toolbar, .toolbar-wrapper");
  if(ellaToolbar){
    var tbParent = ellaToolbar.closest("toolbar-item") || ellaToolbar;
    tbParent.style.display = "none";
  }

  var path = window.location.pathname;
  var pathParts = path.replace(/\/$/,"").split("/");
  /* /collections/handle or /collections/handle/tag1+tag2 */
  var collHandle = pathParts[2] || "";
  var activeTags = pathParts[3] ? decodeURIComponent(pathParts[3]).split("+") : [];

  if(!collHandle) return;

  var SORT_OPTIONS = [
    {value:"title-ascending",  label:"Part Number A → Z"},
    {value:"title-descending", label:"Part Number Z → A"},
    {value:"created-descending",label:"Newest First"},
    {value:"best-selling",     label:"Most Popular"},
    {value:"price-ascending",  label:"Price: Low → High"},
    {value:"price-descending", label:"Price: High → Low"}
  ];

  /* Filter definitions: chips for low-cardinality, dropdown for high-cardinality */
  var FILTER_DEFS = [
    {key:"status", label:"Lifecycle", mode:"chip",
     colors:{"active":"#16a34a","obsolete":"#dc2626","nrnd":"#d97706","discontinued-at-digi-key":"#9333ea"}},
    {key:"pkg",    label:"Package",   mode:"dropdown"},
    {key:"mount",  label:"Mounting",  mode:"chip"},
    {key:"rohs",   label:"RoHS",      mode:"chip", colors:{"compliant":"#16a34a","non-compliant":"#dc2626"}},
    {key:"type",   label:"Type",      mode:"dropdown"}
  ];

  function ready(fn){document.readyState!=="loading"?fn():document.addEventListener("DOMContentLoaded",fn)}

  ready(function(){
    var grid = document.getElementById("main-collection-product-grid");
    if(!grid) return;

    /* ── Fetch ALL product tags via JSON API for facet counts ── */
    var allProducts = [];
    function fetchAll(pg, cb){
      fetch("/collections/" + collHandle + "/products.json?limit=250&page=" + pg)
        .then(function(r){ return r.json() })
        .then(function(data){
          if(data.products && data.products.length){
            allProducts = allProducts.concat(data.products);
            if(data.products.length >= 250) fetchAll(pg+1, cb);
            else cb();
          } else cb();
        }).catch(function(){ cb() });
    }

    fetchAll(1, function(){
      /* Parse facets */
      var facets = {};
      allProducts.forEach(function(p){
        var tags = p.tags || "";
        if(Array.isArray(tags)) tags = tags.join(", ");
        tags.split(", ").forEach(function(t){
          var parts = t.split(":");
          if(parts.length === 2){
            var k = parts[0].trim(), v = parts[1].trim();
            FILTER_DEFS.forEach(function(fd){
              if(fd.key === k){
                if(!facets[k]) facets[k] = {};
                if(!facets[k][v]) facets[k][v] = 0;
                facets[k][v]++;
              }
            });
          }
        });
      });

      render(facets);
    });

    function navigate(tags, sort){
      var base = "/collections/" + collHandle;
      if(tags.length) base += "/" + tags.join("+");
      var params = new URLSearchParams(window.location.search);
      if(sort) params.set("sort_by", sort);
      var qs = params.toString();
      window.location.href = base + (qs ? "?" + qs : "");
    }

    function toggleTag(tag){
      var idx = activeTags.indexOf(tag);
      var newTags = activeTags.slice();
      if(idx > -1) newTags.splice(idx, 1);
      else newTags.push(tag);
      navigate(newTags);
    }

    function render(facets){
      var toolbar = document.createElement("div");
      toolbar.className = "wwd-semi-toolbar";

      /* ── Row 1: Product count + Sort ── */
      var topRow = document.createElement("div");
      topRow.className = "wwd-st-top";

      var countEl = document.createElement("span");
      countEl.className = "wwd-st-count";
      /* Get total from page */
      var totalMatch = document.body.innerHTML.match(/of\s+([\d,]+)\s*total/i);
      var totalCount = totalMatch ? totalMatch[1] : allProducts.length;
      countEl.innerHTML = '<strong>' + totalCount + '</strong> components';
      topRow.appendChild(countEl);

      /* Sort dropdown */
      var sortWrap = document.createElement("div");
      sortWrap.className = "wwd-st-sort";
      var sortIcon = document.createElement("span");
      sortIcon.innerHTML = '<svg width="14" height="14" fill="none" stroke="#64748b" stroke-width="2" viewBox="0 0 24 24"><path d="M3 6h18M7 12h10M10 18h4"/></svg>';
      sortWrap.appendChild(sortIcon);
      var sortSelect = document.createElement("select");
      sortSelect.className = "wwd-st-sort-select";
      var currentSort = new URLSearchParams(window.location.search).get("sort_by") || "best-selling";
      SORT_OPTIONS.forEach(function(opt){
        var o = document.createElement("option");
        o.value = opt.value;
        o.textContent = opt.label;
        if(opt.value === currentSort) o.selected = true;
        sortSelect.appendChild(o);
      });
      sortSelect.addEventListener("change", function(){
        navigate(activeTags, sortSelect.value);
      });
      sortWrap.appendChild(sortSelect);
      topRow.appendChild(sortWrap);
      toolbar.appendChild(topRow);

      /* ── Row 2: Filters ── */
      var filterRow = document.createElement("div");
      filterRow.className = "wwd-st-filters";

      FILTER_DEFS.forEach(function(fd){
        if(!facets[fd.key]) return;
        var values = Object.keys(facets[fd.key]);
        if(values.length < 1) return;
        /* Skip single-value facets */
        if(values.length === 1 && fd.mode === "chip") return;

        /* Sort: by count desc */
        values.sort(function(a,b){ return facets[fd.key][b] - facets[fd.key][a] });

        var group = document.createElement("div");
        group.className = "wwd-st-filter-group";

        var groupLabel = document.createElement("span");
        groupLabel.className = "wwd-st-group-label";
        groupLabel.textContent = fd.label;
        group.appendChild(groupLabel);

        if(fd.mode === "dropdown" || values.length > 6){
          /* Dropdown for high-cardinality */
          var select = document.createElement("select");
          select.className = "wwd-st-filter-select";
          var allOpt = document.createElement("option");
          allOpt.value = "";
          allOpt.textContent = "All " + fd.label + " (" + allProducts.length + ")";
          select.appendChild(allOpt);

          values.forEach(function(val){
            var o = document.createElement("option");
            var tag = fd.key + ":" + val;
            o.value = tag;
            o.textContent = val.replace(/-/g, " ") + " (" + facets[fd.key][val] + ")";
            if(activeTags.indexOf(tag) > -1) o.selected = true;
            select.appendChild(o);
          });

          select.addEventListener("change", function(){
            /* Remove any existing tag for this key */
            var newTags = activeTags.filter(function(t){ return !t.startsWith(fd.key + ":") });
            if(select.value) newTags.push(select.value);
            navigate(newTags);
          });
          group.appendChild(select);

        } else {
          /* Chips for low-cardinality */
          values.forEach(function(val){
            var tag = fd.key + ":" + val;
            var chip = document.createElement("button");
            chip.className = "wwd-st-chip" + (activeTags.indexOf(tag) > -1 ? " wwd-st-chip--active" : "");

            if(fd.colors && fd.colors[val]){
              var dot = document.createElement("span");
              dot.className = "wwd-st-dot";
              dot.style.background = fd.colors[val];
              chip.appendChild(dot);
            }

            var label = document.createElement("span");
            label.textContent = val.replace(/-/g, " ") + " " + facets[fd.key][val];
            chip.appendChild(label);

            chip.addEventListener("click", function(){ toggleTag(tag) });
            group.appendChild(chip);
          });
        }

        filterRow.appendChild(group);
      });

      if(filterRow.children.length > 0){
        toolbar.appendChild(filterRow);
      }

      /* ── Row 3: Active filter summary + clear ── */
      if(activeTags.length > 0){
        var summary = document.createElement("div");
        summary.className = "wwd-st-active";

        activeTags.forEach(function(tag){
          var pill = document.createElement("span");
          pill.className = "wwd-st-active-pill";
          pill.innerHTML = tag.replace(/-/g," ") + ' <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg>';
          pill.addEventListener("click", function(){ toggleTag(tag) });
          summary.appendChild(pill);
        });

        var clearAll = document.createElement("button");
        clearAll.className = "wwd-st-clear";
        clearAll.textContent = "Clear all";
        clearAll.addEventListener("click", function(){ navigate([]) });
        summary.appendChild(clearAll);

        toolbar.appendChild(summary);
      }

      /* ── Insert before product grid ── */
      var gridParent = grid.closest(".collection") || grid.parentElement;
      if(gridParent){
        gridParent.parentElement.insertBefore(toolbar, gridParent);
      }
    }
  });
})();
